import React from 'react';
import { ApprovementStatus, ApproveRejectActions } from '../../../components';

const columns = (handleActions, ability) => [
  {
    name: 'TRABAJADOR',
    selector: 'employee_name',
    sortable: true,
    grow: '2'
  },
  {
    name: 'TIPO',
    selector: 'other_request_type_name',
    sortable: true,
    grow: '2'
  },
  {
    name: 'FECHA DESDE',
    selector: 'start_date',
    cell: item => (item.start_date ? item.start_date : '-'),
    sortable: true,
    grow: '1'
  },
  {
    name: 'FECHA HASTA',
    selector: 'end_date',
    cell: item => (item.end_date ? item.end_date : '-'),
    sortable: true,
    grow: '1'
  },
  {
    name: 'ADICIONAL',
    selector: 'additional',
    cell: item => (item.additional ? `${item.additional.substring(0, 50)}...` : ''),
    sortable: true,
    grow: '2'
  },
  {
    name: 'ESTADO',
    selector: 'status',
    cell: item => <ApprovementStatus status={item.status} />,
    sortable: true,
    grow: '1',
    center: true
  },
  {
    name: 'FECHA SOLICITUD',
    selector: 'created_at',
    sortable: true,
    grow: '1'
  },
  {
    name: 'ACCIONES',
    cell: item => (
      <ApproveRejectActions
        item={item}
        resource="OtherRequest"
        ability={ability}
        clickHandler={handleActions}
        withApprove
        withReject
        withShow
        withDestroy
        withResend
      />
    ),
    ignoreRowClick: true,
    allowOverflow: false,
    button: true,
    grow: '1',
    minWidth: '150px'
  }
];

export default columns;